const add = {
  path: 'add',
  component: resolve => require(['../../../../../../../pages/admin/merchant/dispose/shopkeeper/add'], resolve),
  meta: {
    requireAuth: true
  }
}

export default add